import React from 'react';
import {Grid, Paper} from '@material-ui/core';

import useStyles from '../../../components/useStyles';

const BasePdf = (
    {
        pdf,
        children,
    }
) => {
    const classes = useStyles();

    return (
        <Grid item xs={12} md={12}>
            <Paper className={classes.paper_center}>
                <br/>
                <div className={classes.whitePaper}>
                    <div className={classes.whitePaper}><a className={'textSize'}><br/>
                        {children}
                    </a>
                    </div>
                </div>
                <br/>

                <button className={"btn btn--primary--solid--long2"}>
                    <Grid className={classes.paper}>
                        <a href={pdf} className={classes.blackText} style={({textDecoration: 'none'})} download>
                            Stáhnout PDF
                        </a>
                    </Grid>
                </button>
                <br/>
                <br/>
            </Paper>
        </Grid>
    );
};
export default BasePdf;
